import { createApp, defineAsyncComponent } from 'vue'
import { createPinia } from 'pinia'
// Capture the install event before lazy routes load.
import './composables/usePwaInstall'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import Ripple from 'primevue/ripple'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { initAuthRefresh } from './stores/auth'
import { buildPrimeLocale } from './i18n/primevueLocale'
import './assets/styles/main.css'
import './assets/styles/dark-theme.css'
import './assets/styles/theme-overrides.css'
import './assets/styles/toast.css'
import Aura from '@primevue/themes/aura'
import InputText from 'primevue/inputtext'
import InputGroup from 'primevue/inputgroup'
import InputGroupAddon from 'primevue/inputgroupaddon'
import InputNumber from 'primevue/inputnumber'
import Textarea from 'primevue/textarea'
import Checkbox from 'primevue/checkbox'
const Password = defineAsyncComponent(() => import('primevue/password'))
import FloatLabel from 'primevue/floatlabel'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import Card from 'primevue/card'
import Panel from 'primevue/panel'
const DataTable = defineAsyncComponent(() => import('primevue/datatable'))
import Column from 'primevue/column'
import Toast from 'primevue/toast'
import Message from 'primevue/message'
import ConfirmDialog from 'primevue/confirmdialog'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
const Select = defineAsyncComponent(() => import('primevue/select'))
const DatePicker = defineAsyncComponent(() => import('primevue/datepicker'))
import ProgressSpinner from 'primevue/progressspinner'
import Tag from 'primevue/tag'
import Tabs from 'primevue/tabs'
import Tab from 'primevue/tab'
import TabList from 'primevue/tablist'
import TabPanel from 'primevue/tabpanel'
import TabPanels from 'primevue/tabpanels'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(PrimeVue, {
  locale: buildPrimeLocale(i18n.global.locale.value),
  theme: {
    preset: Aura,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark',
      cssLayer: false
    }
  },
  ripple: true,
  // Nút trang đầu/trước/sau/cuối của PrimeVue không có tên truy cập: lấy từ locale (đổi ngôn ngữ vẫn đúng).
  pt: {
    paginator: {
      first: () => ({ 'aria-label': i18n.global.te('common.table.firstPage') ? i18n.global.t('common.table.firstPage') : (i18n.global.locale.value === 'en' ? 'First page' : 'Trang đầu') }),
      prev: () => ({ 'aria-label': i18n.global.te('common.table.prevPage') ? i18n.global.t('common.table.prevPage') : (i18n.global.locale.value === 'en' ? 'Previous page' : 'Trang trước') }),
      next: () => ({ 'aria-label': i18n.global.te('common.table.nextPage') ? i18n.global.t('common.table.nextPage') : (i18n.global.locale.value === 'en' ? 'Next page' : 'Trang sau') }),
      last: () => ({ 'aria-label': i18n.global.te('common.table.lastPage') ? i18n.global.t('common.table.lastPage') : (i18n.global.locale.value === 'en' ? 'Last page' : 'Trang cuối') })
    }
  }
})
app.use(ToastService)
app.use(ConfirmationService)

app.directive('tooltip', Tooltip)
app.directive('ripple', Ripple)

// Global components — mirrors the admin-ui registration list so any view
// can use these PrimeVue components without a per-file import.
app.component('InputText', InputText)
app.component('InputGroup', InputGroup)
app.component('InputGroupAddon', InputGroupAddon)
app.component('InputNumber', InputNumber)
app.component('Textarea', Textarea)
app.component('Checkbox', Checkbox)
app.component('Password', Password)
app.component('FloatLabel', FloatLabel)
app.component('Button', Button)
app.component('Dialog', Dialog)
app.component('Card', Card)
app.component('Panel', Panel)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Toast', Toast)
app.component('Message', Message)
app.component('ConfirmDialog', ConfirmDialog)
app.component('IconField', IconField)
app.component('InputIcon', InputIcon)
app.component('Select', Select)
app.component('DatePicker', DatePicker)
app.component('ProgressSpinner', ProgressSpinner)
app.component('Tag', Tag)
app.component('Tabs', Tabs)
app.component('Tab', Tab)
app.component('TabList', TabList)
app.component('TabPanel', TabPanel)
app.component('TabPanels', TabPanels)

app.mount('#app')
initAuthRefresh()

import '@/pwa/mobile.css'
